import * as Yup from "yup";

export const initialValues = {
  switchById: null,
  switchWithId: null,
  startDate: null,
  endDate: null,
  from: null,
  to: null,
  other: null,
  approver: null,
};

const SwaoShiftSchema = Yup.object().shape({
  // switchBy: Yup.string().required("Please select."),
  // switchWith: Yup.string().required("Please select."),
  startDate: Yup.string().required("Please select."),
  // endDate: Yup.string().required("Please select."),
  other: Yup.string().required("Please enter."),
});

export default SwaoShiftSchema;


